import { useAuthStore } from '@/stores/auth.ts';

export default function getAppName() {
	const appName = useAuthStore().isLux ? 'lux.up.app' : 'be.monizze.app';

	switch (import.meta.env.VITE_ENV) {
		case 'develop':
			return appName + '.dev';
		case 'staging':
			return appName + '.stg';
		default:
			return appName;
	}
}
